/* eslint class-methods-use-this: 0 */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Glyphicon, Modal } from 'react-bootstrap';
import SessionStore from 'stores/SessionStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import ProTip from '../../../ui/ProTip';
import { PodUploader } from '../../documents/PodUploader';
import { PodDocumentsList } from '../../documents/PodDocumentsList';
const downloadFile = (url) => window.open(url);
class StopDocumentPreviewModal extends Component {
    constructor(props) {
        super(props);
        this.handleComplete = async () => {
            if (!this.props.onStopComplete) {
                return;
            }
            const { shipment, stop } = this.props;
            const { timeline: { complete: { meta: { signatory }, }, }, } = stop;
            const meta = {
                signatory,
                date: moment().toISOString(),
                value: '',
                name: '',
                reasonCode: '',
                reasonDescription: '',
            };
            const container = stop.equipments.find((eq) => eq._equipmentType === 'container');
            if (container) {
                meta.containerId = container.equipment_id;
            }
            const pods = this.state.files;
            if (pods.length) {
                meta.files = pods.map((document) => {
                    return {
                        key: document.key,
                        id: document.id,
                        bucket: document.bucket,
                        type: 'shipmentdata',
                    };
                });
            }
            this.props.onStopComplete(shipment, stop, [], meta);
            this.hide();
        };
        this.handleFileDownload = (files) => {
            files.forEach((file) => downloadFile(file.signedUrl));
        };
        this.handleShowEdit = () => this.setState({ editMode: true });
        this.handleCancelEdit = () => this.setState({ editMode: false });
        this.hide = () => {
            this.setState({
                documents: [],
                show: false,
            });
            this.props.onHide();
        };
        this.state = {
            editMode: false,
            documents: [],
            files: [],
        };
    }
    render() {
        var _a, _b;
        if (!this.props.stop)
            return null;
        const { t } = this.props;
        const pocDocs = this.state.documents;
        const isAdmin = SessionStore.isAdmin();
        return (React.createElement(Modal, { show: this.props.show, onHide: this.hide, style: { top: '34%' } },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, t('FILE_PREVIEW'))),
            React.createElement(Modal.Body, null,
                React.createElement("div", null,
                    React.createElement("h3", { className: "text-xl mt-0 mb-4" }, t('PROOF_OF_COMPLETION')),
                    React.createElement(ProTip, { message: t('CLICK_IMAGE_TO_DOWNLOAD_FILE'), className: { 'mb-4': true } }),
                    this.props.show && (React.createElement(PodDocumentsList, { shipment: this.props.shipment, stop: this.props.stop, onInit: (documents) => {
                            this.setState({
                                documents,
                            });
                        } }))),
                this.state.editMode && (React.createElement(PodUploader, { shipment: this.props.shipment, stop: this.props.stop, meta: (_b = (_a = this.props.stop.timeline) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.meta, handleComplete: this.handleComplete, onUpload: (shipment, stop, type, uploadedFile) => {
                        this.setState({
                            files: [uploadedFile],
                        });
                    } })),
                React.createElement("div", { className: "my-4 flex flex-wrap justify-between" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "form-label block mb-2" }, t('SIGNATORY')),
                        React.createElement("span", null, this.props.stop.signatory)),
                    React.createElement("div", { className: "preview-actions flex" },
                        React.createElement("button", { type: "button", className: "button button-green mr-2", title: t('DOWNLOAD_POD'), onClick: () => this.handleFileDownload(pocDocs) },
                            React.createElement(Glyphicon, { glyph: "download" }),
                            React.createElement("span", { className: "ml-2" }, titleize(t('DOWNLOAD')))),
                        isAdmin && !this.state.editMode && (React.createElement("button", { type: "button", title: t('REPLACE_POD'), className: "button button-hollow-green mr-2", onClick: this.handleShowEdit },
                            React.createElement(Glyphicon, { glyph: "upload" }),
                            React.createElement("span", { className: "ml-2" }, t('ATTACH_DOCUMENTS')))),
                        isAdmin && this.state.editMode && (React.createElement("button", { type: "button", title: t('CANCEL_EDIT'), className: "button button-secondary", onClick: this.handleCancelEdit }, t('CANCEL_EDIT'))))))));
    }
}
StopDocumentPreviewModal.propTypes = {
    shipment: PropTypes.object.isRequired,
    stop: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onStopComplete: PropTypes.func,
};
export default withTranslation()(StopDocumentPreviewModal);
